import React from 'react';
import { Col, Row, Tooltip, Space } from 'antd';
import { useTranslation } from 'react-i18next';

import { StyledTitle } from 'components/StyledTitle';
import { Icon } from 'components/Icon';
import { Markdown } from 'components';

import { Title } from './styledComponents';

export const Header = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledTitle color="var(--text-color-secondary)" level={3}>
      <Row align="middle" gutter={8}>
        <Col>{t('claims.shortfall.title')}</Col>
        <Col>
          <Row align="middle">
            <Tooltip
              title={
                <Space direction="vertical" size="small">
                  <Title strong>{t('cms.shortfall.info.title')}</Title>
                  <Markdown>{t('cms.shortfall.info.description')}</Markdown>
                </Space>
              }
            >
              <Icon name="Info" width={15} />
            </Tooltip>
          </Row>
        </Col>
      </Row>
    </StyledTitle>
  );
};
